import React, { useState } from 'react';

const SWIPE_THRESHOLD = 40;

const ProductCarousel = ({ images, name }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);

  const goNext = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  const goPrev = () => {
    setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const onTouchStart = (event) => {
    setTouchStartX(event.changedTouches[0].clientX);
  };

  const onTouchMove = (event) => {
    setTouchEndX(event.changedTouches[0].clientX);
  };

  const onTouchEnd = () => {
    const swipeDistance = touchStartX - touchEndX;

    if (swipeDistance > SWIPE_THRESHOLD) {
      goNext();
    }

    if (swipeDistance < -SWIPE_THRESHOLD) {
      goPrev();
    }
  };

  return (
    <div
      className="product-carousel"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <button
        className="carousel-control carousel-control-left"
        onClick={goPrev}
        aria-label={`Previous image of ${name}`}
      >
        &#8249;
      </button>

      <img
        src={images[activeIndex]}
        alt={`${name} view ${activeIndex + 1}`}
        className="product-image"
      />

      <button
        className="carousel-control carousel-control-right"
        onClick={goNext}
        aria-label={`Next image of ${name}`}
      >
        &#8250;
      </button>

      <div className="carousel-dots" aria-hidden="true">
        {images.map((_, index) => (
          <span
            key={`${name}-${index}`}
            className={`carousel-dot ${index === activeIndex ? 'active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductCarousel;
